export interface RequestCekAchievementAssignTaskDto {
  module: string;
  TaskAssigne: string;
}

export interface RequestCekAchievementDto {
  badgeModule: string;
}

export enum badgeModule{
  attendanceIn = 'AttendanceIn',
  taskCaptain = 'TaskCaptain',
  taskFinisher = 'TaskFinisher'
}

export interface RequestCekAchievementTaskCompletedDto {
  type: string;
  TaskFinisher: string;
}

export interface RequestDetailAchievementEmployeeDto {
  empId: string;
  badgeId: number
}

export interface RequestaAddMasterBadgeDto {
  name: string;
  urlImage: string;
  moduleName: string;
  description: string;
}

export interface RequestAddMasterPointDto {
  name: string;
  badgeId: number;
  level: number;
  pointLevel: number;
  point: number;
  description: string;
  remark: string;
}

export interface RequestUpdateMasterPointDto {
  id: number;
  level: number;
  pointLevel: number;
}

export interface Tgospgmfmbadge {
  id: number;
  name: string;
  urlImage?: any;
  moduleName: string;
  description: string;
  datetimeCreated: Date;
  createdBy?: any;
  datetimeModified: Date;
  modifiedBy?: any;
}
export interface AchivementData {
  id: number;
  badgeId: number;
  empId: string;
  level: number;
  flagFavorite: number;
  checked: number;
  progressPoint: number;
  totalPoint: number;
  totalAchievment: number;
  startDateCheck: Date;
  datetimeCreated: Date;
  createdBy: string;
  datetimeModified: Date;
  modifiedBy: string;
  tgospgmfmbadge: Tgospgmfmbadge;
}

export interface ResponseGetAchivement {
  message: string;
  data: AchivementData
}


export interface ResponseGetBadgeOnAvatarDto{
  id: number;
  badgeId: string;
  companyId: number;
  empId: string;
  level: number;
  flagFavorite: number;
  flagAvatar: number;
  progressPoint: number;
  totalPoint: number;
  totalAchievment: number;
  startDateCheck: string;
  datetimeCreated: string;
  createdBy?: any;
  datetimeModified: string;
  modifiedBy?: any;
  tgospgmfmbadge: GetBadgeOnDto;
}

export interface GetBadgeOnDto {
  id: string;
  name: string;
  moduleName: string;
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/gamification.dto.ts